<div class="navbar navbar-expand-xg navbar-expand-lg navbar-expand-md align-items-center top-content pb-5 pt-1" style="padding: 0px;">
  <div *ngIf="images && images.length > 0" class="col-xg-12 col-lg-12 col-md-12 col-xs-12 photos-modal-hotel" style="border-radius: 6px; padding: 0px; background-color: #fff">
    <div class="custom-carousel-wrapper">
      <div class="custom-carousel-container" *ngIf="images && images.length > 0">
        <div class="custom-carousel-track" #carouselTrack (scroll)="onScroll()">
          <div class="custom-carousel-slide"
              *ngFor="let img of duplicatedImages; let i = index"
              [attr.data-index]="i"
              [class.active]="(i % images.length) === currentIndex"
              (click)="selectImage(i % images.length)">
            <img [src]="img.image"
                [alt]="img.description || 'Imagen del hotel'"
                onerror="if (this.src != 'assets/img/app/hotel_default.png') this.src = 'assets/img/app/hotel_default.png';">
          </div>
        </div>
      </div>

      <!-- Círculos con números y puntos suspensivos - Sliding Window -->
      <div class="custom-carousel-dots-numbered" *ngIf="images && images.length > 0">
        <div class="dots-numbered-wrapper">
          <!-- Flecha izquierda -->
          <button class="nav-arrow prev-arrow" (click)="prevImage()" [disabled]="loading">
                 <i class="bi bi-caret-left-fill"></i>
          </button>

          <!-- Círculos numerados dinámicos -->
          <div class="dots-numbered-container">
            <div *ngFor="let dot of getVisibleDots(); trackBy: trackByDot"
                class="dot-numbered"
                [ngStyle]="{'color': !dot.isEllipsis && currentIndex === dot.index ? getClientsSettingAppBooking?.clients_setting_global?.color_main_1 : 'black'}"
                [class.active]="!dot.isEllipsis && currentIndex === dot.index"
                [class.ellipsis-dot]="dot.isEllipsis"
                (click)="!dot.isEllipsis && selectImage(dot.index)">
              {{ dot.label }}
            </div>
          </div>

          <!-- Flecha derecha -->
          <button class="nav-arrow next-arrow" (click)="nextImage()" [disabled]="loading">
            <i class="bi bi-caret-right-fill"></i>
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="images && images.length === 0" class="col-xg-12 col-lg-12 col-md-12 col-xs-12 photos-modal-hotel" style="border-radius: 6px; padding: 0px; border: 1px solid #ccc; background-color: #fff">
      <div class="d-flex justify-content-center align-items-center" style="height: 450px;">
        <p class="semiblack" style="font-family: 'Rubik', serif; font-size: 28px; font-weight: 600;">No hay fotos para este producto</p>
      </div>
    </div>
  </div>
</div>
